import { Component, forwardRef, input, model } from '@angular/core';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
    selector: 'app-textarea',
    templateUrl: './textarea.component.html',
    standalone: true,
    imports: [FormsModule],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => Textarea),
            multi: true,
        },
    ],
})
export class Textarea implements ControlValueAccessor {
    placeholder = input<string>('');
    required = input<boolean>(false);
    readonly = input<boolean>(false);
    maxLength = input<number>(3000);
    value = model<string>('');

    private onChange: (value: string) => void = () => {};
    private onTouched: () => void = () => {};

    writeValue(obj: any): void {
        this.value.set(obj || '');
    }

    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }

    setDisabledState(isDisabled: boolean): void {
        // Implement if needed
    }

    updateValue(newValue: string): void {
        this.value.set(newValue);
        this.onChange(newValue);
        this.onTouched();
    }
}
